import { injectable } from "inversify";
import { Data } from '@singularsystems/neo-core';
import { AppService, Types } from '../AwardsTypes';
import { LifeTime } from 'st-app/Models/Enums/LifeTime';
import IncentiveGroupLookup from "st-common/Awards/Models/IncentiveSchemes/IncentiveGroupLookup";
import { ApproverApprovalSummaryLookup } from 'st-common/Awards/Models/Approvals/Queries/ApproverApprovalSummaryLookup';

@injectable()
export default class AwardsDataCache extends Data.CachedDataService {

    constructor(
        private catalogueApi = AppService.get(Types.Awards.ApiClients.CatalogueQueryApiClient),
        private incentiveSchemesApi = AppService.get(Types.Awards.ApiClients.IncentiveSchemesQueryApiClient),
        private incentiveGroupsApiClient = AppService.get(Types.Awards.ApiClients.IncentiveGroupsQueryApiClient),
        private moduleConfigApiClient = AppService.get(Types.Awards.ApiClients.AwardModuleConfigApiClient),
        private approvalsQueryApiClient = AppService.get(Types.Awards.ApiClients.ApprovalsQueryApiClient)) {
        super();
     }

    public instruments = this.register(this.catalogueApi.getInstrumentLookup, LifeTime.Long);
    public incentiveSchemes = this.register(this.incentiveSchemesApi.getLookupAll, LifeTime.Short);
    public particpantIncentiveSchemes = this.register(this.incentiveSchemesApi.getParticipantIncentiveSchemeLookup, LifeTime.Long);
    public incentiveGroupsLookup = this.registerList(IncentiveGroupLookup, this.incentiveGroupsApiClient.getLookupList, LifeTime.Long);

    public awardModuleConfig = this.register(this.moduleConfigApiClient.get, LifeTime.Long);
    public approverApprovalSummary = this.register(this.approvalsQueryApiClient.getApproverApprovalSummaryAsync, LifeTime.Short);

    public get hasPendingApprovals(): boolean {
        return (this.approverApprovalSummary.currentData?.awards?.length ?? 0) > 0;
    }

    public async initialize(): Promise<void> {
        await Promise.allSettled([
            this.awardModuleConfig.getDataAsync(),
            this.approverApprovalSummary.getDataAsync(),
        ]);
    }
}